<template>
    <div>
        <div class="order-userInfo">
            <div class="userInfo-wrapper">
                <div class="userInfo-border">
                    <h5>基本设置</h5>
                    <el-row class="userInfo-group">
                        <el-row>
                            <el-col :span="8" class="order-item">服务时间：<span>{{new Date(product.content.start_at).toLocaleDateString()}}-{{new Date(product.content.end_at).toLocaleDateString()}}</span>
                            </el-col>
                            <el-col :span="8" class="order-item">备注：<span>{{product.content.coin_setting.memo}}</span>
                            </el-col>
                        </el-row>
                    </el-row>
                </div>
            </div>
            <div class="userInfo-wrapper">
                <div class="userInfo-border">
                    <h5>额度设置</h5>
                    <el-row class="userInfo-group">
                        <el-row class="set-number">
                            <div class="order-item" style="float:left; width:160px; margin-right:30px;">日下载次数设置</div>
                            <el-row>
                                <el-col :span="3" class="order-item">
                                    总：{{product.content.day_time_setting.all}}
                                    <span v-html="showOldConfig('day_time_setting','all')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    普：{{product.content.day_time_setting.pu}}
                                    <span v-html="showOldConfig('day_time_setting','pu')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    精：{{product.content.day_time_setting.jing}}
                                    <span v-html="showOldConfig('day_time_setting','jing')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    特：{{product.content.day_time_setting.te}}
                                    <span v-html="showOldConfig('day_time_setting','te')"></span>
                                </el-col>
                            </el-row>
                        </el-row>
                        <el-row class="set-number">
                            <div class="order-item" style="float:left; width:160px; margin-right:30px;">总下载次数设置</div>
                            <el-row  v-if="product.content && product.content.day_time_all_setting">
                                <el-col :span="3" class="order-item">
                                    总：{{product.content.day_time_all_setting.all}}
                                    <span v-html="showOldConfig('day_time_all_setting','all')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    普：{{product.content.day_time_all_setting.pu}}
                                    <span v-html="showOldConfig('day_time_all_setting','pu')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    精：{{product.content.day_time_all_setting.jing}}
                                    <span v-html="showOldConfig('day_time_all_setting','jing')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    特：{{product.content.day_time_all_setting.te}}
                                    <span v-html="showOldConfig('day_time_all_setting','te')"></span>
                                </el-col>
                            </el-row>
                        </el-row>
                        <el-row class="set-number">
                            <div class="order-item" style="float:left; width:160px; margin-right:30px;">单账号日下载次数设置</div>
                            <el-row>
                                <el-col :span="3" class="order-item">
                                    总：{{product.content.single_account_time_setting.all}}
                                    <span v-html="showOldConfig('single_account_time_setting','all')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    普：{{product.content.single_account_time_setting.pu}}
                                    <span v-html="showOldConfig('single_account_time_setting','pu')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    精：{{product.content.single_account_time_setting.jing}}
                                    <span v-html="showOldConfig('single_account_time_setting','jing')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    特：{{product.content.single_account_time_setting.te}}
                                    <span v-html="showOldConfig('single_account_time_setting','te')"></span>
                                </el-col>
                            </el-row>
                        </el-row>
                        <el-row class="set-number">
                            <div class="order-item" style="float:left; width:160px; margin-right:30px;">单账号总下载次数设置</div>
                            <el-row v-if="product.content && product.content.single_account_time_all_setting">
                                <el-col :span="3" class="order-item">
                                    总：{{product.content.single_account_time_all_setting.all}}
                                    <span v-html="showOldConfig('single_account_time_all_setting','all')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    普：{{product.content.single_account_time_all_setting.pu}}
                                    <span v-html="showOldConfig('single_account_time_all_setting','pu')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    精：{{product.content.single_account_time_all_setting.jing}}
                                    <span v-html="showOldConfig('single_account_time_all_setting','jing')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    特：{{product.content.single_account_time_all_setting.te}}
                                    <span v-html="showOldConfig('single_account_time_all_setting','te')"></span>
                                </el-col>
                            </el-row>
                        </el-row>
                        <el-row class="set-number">
                            <div class="order-item" style="float:left; width:160px; margin-right:30px;">学币数量设置</div>
                            <el-row>
                                <el-col :span="3" class="order-item">
                                    总：{{product.content.coin_setting.sums}}
                                    <span v-html="showOldConfig('coin_setting','sums')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    普：{{product.content.coin_setting.pu}}
                                    <span v-html="showOldConfig('coin_setting','pu')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    精：{{product.content.coin_setting.jing}}
                                    <span v-html="showOldConfig('coin_setting','jing')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    特：{{product.content.coin_setting.te}}
                                    <span v-html="showOldConfig('coin_setting','te')"></span>
                                </el-col>
                            </el-row>
                        </el-row>
                        <el-row class="set-number">
                            <div class="order-item" style="float:left; width:160px; margin-right:30px;">单账号学币数量设置</div>
                            <el-row v-if="product.content && product.content.single_coin_setting">
                                <el-col :span="3" class="order-item">
                                    总：{{product.content.single_coin_setting.sums}}
                                    <span v-html="showOldConfig('single_coin_setting','sums')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    普：{{product.content.single_coin_setting.pu}}
                                    <span v-html="showOldConfig('single_coin_setting','pu')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    精：{{product.content.single_coin_setting.jing}}
                                    <span v-html="showOldConfig('single_coin_setting','jing')"></span>
                                </el-col>
                                <el-col :span="3" class="order-item">
                                    特：{{product.content.coin_setting.te}}
                                    <span v-html="showOldConfig('single_coin_setting','te')"></span>
                                </el-col>
                            </el-row>
                        </el-row>
                    </el-row>
                </div>
            </div>
            <div class="userInfo-wrapper">
                <div class="userInfo-border">
                    <h5>车厢设置:{{product.content.box_setting.id}}:{{product.content.box_setting.name}}</h5>
                    <el-row class="userInfo-group">
                        <el-row class="set-number">
                            <div class="order-item" style="float:left; width:120px; ">日下载次数限制</div>
                            <el-row>
                                <el-col :span="5" class="order-item">
                                    总：{{product.content.box_setting.day.all}}
                                    <span v-html="showOldBoxConfigOther('day','all')"></span>
                                </el-col>
                                <el-col :span="5" class="order-item">
                                    普：{{product.content.box_setting.day.pu}}
                                    <span v-html="showOldBoxConfigOther('day','pu')"></span>
                                </el-col>
                                <el-col :span="5" class="order-item">
                                    精：{{product.content.box_setting.day.jing}}
                                    <span v-html="showOldBoxConfigOther('day','jing')"></span>
                                </el-col>
                                <el-col :span="5" class="order-item">
                                    精：{{product.content.box_setting.day.te}}
                                    <span v-html="showOldBoxConfigOther('day','te')"></span>
                                </el-col>
                            </el-row>
                        </el-row>
                        <el-row class="set-number" v-if="product.content.box_setting.all">
                            <div class="order-item"  style="float:left; width:120px; ">总下载次数限制</div>
                            <el-row>
                                <el-col :span="5" class="order-item">
                                    总：{{product.content.box_setting.all.all}}
                                    <span v-html="showOldBoxConfigOther('all','all')"></span>
                                </el-col>
                                <el-col :span="5" class="order-item">
                                    普：{{product.content.box_setting.all.pu}}
                                    <span v-html="showOldBoxConfigOther('all','pu')"></span>
                                </el-col>
                                <el-col :span="5" class="order-item">
                                    精：{{product.content.box_setting.all.jing}}
                                    <span v-html="showOldBoxConfigOther('all','jing')"></span>
                                </el-col>
                                <el-col :span="5" class="order-item">
                                    精：{{product.content.box_setting.all.te}}
                                    <span v-html="showOldBoxConfigOther('all','te')"></span>
                                </el-col>
                            </el-row>
                        </el-row>
                        <el-row class="set-number" v-for="(ip, key) in product.content.box_setting.ips" :key="key">
                            <div class="order-item" style="float:left;width:120px; ">IP段设置</div>
                            <el-row>
                                <el-col :span="10" class="order-item">
                                    开始ip：{{ip.start_ip}}
                                    结束ip：{{ip.end_ip}}
                                </el-col>
                            </el-row>
                        </el-row>
                        <el-row class="set-number">
                            <div class="order-item" style="float:left; width:120px; ">学币总量使用限制</div>
                            <el-row>
                                <el-col :span="5" class="order-item">
                                    总：{{product.content.box_setting.coin}}
                                    <span v-html="showOldBoxConfigOther('coin','')"></span>
                                </el-col>
                                <el-col :span="5" class="order-item">
                                    精：{{product.content.box_setting.jing}}
                                    <span v-html="showOldBoxConfigOther('jing','')"></span>
                                </el-col>
                                <el-col :span="5" class="order-item">
                                    普：{{product.content.box_setting.pu}}
                                    <span v-html="showOldBoxConfigOther('pu','')"></span>
                                </el-col>
                                <el-col :span="5" class="order-item">
                                    特：{{product.content.box_setting.te}}
                                    <span v-html="showOldBoxConfigOther('te','')"></span>
                                </el-col>
                            </el-row>
                        </el-row>
                        <el-row :span="8" class="order-item">备注：<span>{{product.content.box_setting.memo}}</span>
                        </el-row>
                    </el-row>
                    <el-table :data="product.content.box_setting.batch" border style="width: 100%;margin-top: -10px;">
                        <el-table-column prop="subject_name" label="科目">
                        </el-table-column>
                        <el-table-column label="小学">
                            <el-table-column prop="config.primary.pu" label="普">
                                <template slot-scope="scope">
                                    {{scope.row.config.primary.pu}}
                                    <span v-html="showOldBoxConfig('primary',scope.row.subject_id,'pu')"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config.primary.jing" label="精">
                                <template slot-scope="scope">
                                    {{scope.row.config.primary.jing}}
                                    <span v-html="showOldBoxConfig('primary',scope.row.subject_id,'jing')"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config.primary.te" label="特">
                                <template slot-scope="scope">
                                    {{scope.row.config.primary.pu}}
                                    <span v-html="showOldBoxConfig('primary',scope.row.subject_id,'te')"></span>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="初中">
                            <el-table-column prop="config.middle.pu" label="普">
                                <template slot-scope="scope">
                                    {{scope.row.config.middle.pu}}
                                    <span v-html="showOldBoxConfig('middle',scope.row.subject_id,'pu')"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config.middle.jing" label="精">
                                <template slot-scope="scope">
                                    {{scope.row.config.middle.jing}}
                                    <span v-html="showOldBoxConfig('middle',scope.row.subject_id,'jing')"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config.middle.te" label="特">
                                <template slot-scope="scope">
                                    {{scope.row.config.middle.te}}
                                    <span v-html="showOldBoxConfig('middle',scope.row.subject_id,'te')"></span>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="高中">
                            <el-table-column prop="config.high.pu" label="普">
                                <template slot-scope="scope">
                                    {{scope.row.config.high.pu}}
                                    <span v-html="showOldBoxConfig('high',scope.row.subject_id,'pu')"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config.high.jing" label="精">
                                <template slot-scope="scope">
                                    {{scope.row.config.high.pu}}
                                    <span v-html="showOldBoxConfig('high',scope.row.subject_id,'jing')"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config.high.te" label="特">
                                <template slot-scope="scope">
                                    {{scope.row.config.high.pu}}
                                    <span v-html="showOldBoxConfig('high',scope.row.subject_id,'te')"></span>
                                </template>
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CustomerService from "~/services/customer";

    export default {
        data() {
            return {
                oldConfig: {},
                oldBoxConfig: ''
            }
        },
        props: {
            product: {
                type: Object,
                required: true
            }
        },
        created() {
            this.getOrder();
            this.box_config();
        },
        methods: {
            getOrder() {
                CustomerService.product_config({
                    product_code: this.product.product_code,
                    customer_id: this.product.customer_id
                }).then(res => {
                    this.oldConfig = res.data;
                })
            },
            showOldConfig(type, need) {
                if (typeof this.oldConfig[type] != "undefined") {
                    //做个对比
                    if(this.product.content[type][need] == this.oldConfig[type][need]) return "";
                    return "<span  style='color: #f5222d'>原来:" + this.oldConfig[type][need] + "</span>";
                }
                return "";
            },
            box_config() {
                CustomerService.box_config({
                    group_id: this.product.content.box_setting.id,
                    customer_id: this.product.customer_id
                }).then(res => {
                    this.oldBoxConfig = res.data;

                })
            },
            showOldBoxConfig(stage, subject_id, type) {
                if (typeof this.oldBoxConfig.batch != "undefined") {
                    if(!subject_id) return "";
                    let item = this.oldBoxConfig.batch.find(i => {
                        return i.subject_id == subject_id
                    });
                    let oldItem = this.product.content.box_setting.batch.find(i => {
                        return i.subject_id == subject_id
                    })
                    if (!item) return "";
                    //做个对比
                    if(oldItem.config[stage][type] == item.config[stage][type]) return "";
                    return "<span  style='color: #f5222d'>原来:" + item.config[stage][type] + "</span>";
                }
                return "";
            },
            showOldBoxConfigOther(type, need='') {
                if (typeof this.oldBoxConfig[type] != "undefined") {
                    if(need){
                        if(this.product.content.box_setting[type][need]==this.oldBoxConfig[type][need]) return "";
                        return "<span  style='color: #f5222d'>原来:" + this.oldBoxConfig[type][need] + "</span>";
                    }
                    if(this.product.content.box_setting[type]==this.oldBoxConfig[type]) return "";
                    return "<span  style='color: #f5222d'>原来:" + this.oldBoxConfig[type] + "</span>";
                }
                return "";
            },
        }

    }
</script>




// WEBPACK FOOTER //
// src/views/order/products/xwt.vue